"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointsValues = exports.getIsPortraitOrientation = void 0;
var ViewPortAdapter_1 = require("powerhooks/ViewPortAdapter");
Object.defineProperty(exports, "getIsPortraitOrientation", { enumerable: true, get: function () { return ViewPortAdapter_1.getIsPortraitOrientation; } });
exports.breakpointsValues = {
    "sm": 600,
    "md": 960,
    "lg": 1280,
    "xl": 1920,
};
//# sourceMappingURL=breakpoints.js.map